import { render, staticRenderFns } from "./VehicleLotItemPage.vue?vue&type=template&id=71206794&scoped=true&"
import script from "./VehicleLotItemPage.vue?vue&type=script&lang=js&"
export * from "./VehicleLotItemPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71206794",
  null
  
)

export default component.exports